import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import ExchangesTable from "MODULES/inventories/components/Detail/Header/DropdownActions/AssignToExchange/ExchangesTable";
import { assignExchange } from "MODULES/inventories/actions";
import validate from "./validate";

const ASSIGN_EXCHANGE_FORM = "assignExchange";

function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row>
          <Col md={12}>
            <ExchangesTable
              partId={props.partId}
              form={ASSIGN_EXCHANGE_FORM}
              lineItems={props.lineItems}
            />
          </Col>
        </Row>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  change: T.func.isRequired,
  inventoryQuantity: T.number.isRequired,
  lineItems: T.arrayOf(T.shape({}))
};

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(assignExchange(data))
}))(
  form({
    form: ASSIGN_EXCHANGE_FORM,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/AssignToExchange/Form.jsx